export default "<div class=\"row footer\">\n    <div class=\"col-sm-12\">\n        <hr>\n    </div>\n</div>"